import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TABS = [
  { name: 'Home',      tKey: 'tabs.home',      icon: '🏠', to: '/student'           },
  { name: 'Progress',  tKey: 'tabs.progress',  icon: '📈', to: '/student/progress'  },
  { name: 'Timetable', tKey: 'tabs.timetable', icon: '📅', to: '/student/timetable' },
  { name: 'More',      tKey: 'tabs.more',      icon: '⚙️', to: '/student/more'      },
] as const;

interface BottomTabBarProps {
  activeTab: string;
}

export function BottomTabBar({ activeTab }: BottomTabBarProps) {
  const { t } = useTranslation();
  return (
    <nav className="tab-bar">
      {TABS.map((tab) => (
        <Link
          key={tab.name}
          to={tab.to}
          className={`tab-item${activeTab === tab.name ? ' active' : ''}`}
        >
          <span className="tab-icon">{tab.icon}</span>
          <span>{t(tab.tKey)}</span>
        </Link>
      ))}
    </nav>
  );
}
